// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__YObZG","text":"style_text__lTyT6","ball-pulse":"style_ball-pulse__r2_k0"};